import { createFileRoute, redirect } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { MapPin } from "lucide-react";
import { PlaceholderPage } from "@/components/vroom/placeholder-page";
import type { RoleKind } from "@/components/vroom/role-pill";

interface SessionUser {
  name: string;
  email: string;
  role?: RoleKind;
}

export const Route = createFileRoute("/_authed/admin/addresses")({
  beforeLoad: ({ context }) => {
    const user = (context as { user?: { role?: string } }).user;
    if (user?.role !== "super_admin") throw redirect({ to: "/dashboard" });
  },
  component: AddressesAdmin,
});

function AddressesAdmin() {
  const { t } = useTranslation();
  const { user } = Route.useRouteContext() as { user: SessionUser };
  return (
    <PlaceholderPage
      user={{ name: user.name, role: "super_admin" }}
      section="admin"
      activeKey="addresses"
      breadcrumb={<>{t("admin.addresses.breadcrumb")}</>}
      title={t("admin.addresses.title")}
      icon={<MapPin size={48} />}
    />
  );
}
